export const greenColor = '#57d9a3';
export const blueColor = '#4c9aff';
export const orangeColor = '#ff991f';
export const redColor = '#ff5630';
